import React from "react";
import AppHeader from "@/components/drill/AppHeader";
import { HardHat } from "lucide-react";

export default function ToolComingSoon({ title }) {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-slate-100 dark:from-slate-950 dark:to-slate-900">
      <AppHeader title={title || "Tool"} subtitle="Drilling field tool" backTo="/" />

      <main className="max-w-7xl mx-auto px-4 sm:px-6 py-16 pb-24 flex flex-col items-center justify-center text-center">
        <div className="w-16 h-16 rounded-full bg-slate-200 dark:bg-slate-800 flex items-center justify-center mb-5">
          <HardHat className="w-8 h-8 text-slate-500 dark:text-slate-400" />
        </div>
        <h2 className="text-2xl font-bold tracking-tight text-slate-900 dark:text-slate-100">
          COMING SOON!
        </h2>
        <p className="text-slate-500 mt-2 text-sm dark:text-slate-400">
          This page is a work in progress.
        </p>
      </main>
    </div>
  );
}